<script>
  let wave1Start = '2020-04-30'
  let wave1End = '2020-10-21'

  let wave2Start = '2020-10-20'
  let wave2End = '2021-04-10'

  let wave3Start = '2021-04-20'
  let wave3End = '2021-10-15'

  let wave4Start = '2021-11-10'
  let wave4End = '2022-03-01'

  import { scaleLinear } from 'd3-scale'
  import { getContext } from 'svelte'
  import { formatThousands, formatDateLong, parseTime } from './functions'
  import AxisManual from './components/AxisManual.svelte'
  import Line from './components/Line.svelte'
  import { colors } from './colors.js'
  import Grid from './components/Grid.svelte'
  import Annotation from './components/Annotation.svelte'

  let { nData, cData, margin } = getContext('chart')
  let cumulativeData = cData()

  let width
  let height = 250
  let latestVaccCount
  let latestDate
  let xScale, yScale
  let xTicks, yTicks
  let mobile = true
  if (window.innerWidth > 500) mobile = false

  cumulativeData.forEach((d) => {
    d.casesSevenDays = +d['7_day_weekly_average']
    d.vaccinationsSevenDays = +d['vaccinations_7_day_average']
  })

  // wave one
  let waveOne = cumulativeData.filter(
    (d, i) => d.date > parseTime(wave1Start) && d.date < parseTime(wave1End)
  )
  let count = 0
  waveOne.forEach((d) => {
    d.marker = count
    count++
  })

  // wave two
  let waveTwo = cumulativeData.filter(
    (d, i) => d.date > parseTime(wave2Start) && d.date < parseTime(wave2End)
  )
  let count2 = 0
  waveTwo.forEach((d) => {
    d.marker = count2
    count2++
  })

  // wave three
  let waveThree = cumulativeData.filter(
    (d, i) => d.date > parseTime(wave3Start) && d.date < parseTime(wave3End)
  )
  let count3 = 0
  waveThree.forEach((d) => {
    d.marker = count3
    count3++
  })

  // wave four
  let waveFour = cumulativeData.filter(
    (d, i) => d.date > parseTime(wave4Start) && d.date < parseTime(wave4End)
  )
  let count4 = 0
  waveFour.forEach((d) => {
    d.marker = count4
    count4++
  })

  $: xScale = scaleLinear()
    .range([margin.left, width - margin.right])
    .domain([0, 175])

  $: yScale = scaleLinear()
    .range([height - margin.bottom, margin.top])
    // .domain([0, max(waveFour, (d) => d.casesSevenDays)])
    .domain([0, 20000])

  $: yTicks = yScale.ticks(9)
  export let manualYTicks = [0, 5000, 10000, 15000, 20000]
  export let manualXTicks = [0, 25, 50, 75, 100, 125, 150]
</script>

<div class="chart-wrap">
  <div class="chart-title">New Daily Cases (7-day average)</div>
  <div class="chart-description">
    Daily new cases in South Africa compared over 175 days<br />
    Updated: {formatDateLong(cumulativeData[cumulativeData.length - 1].date)}
  </div>
  <div class="chart-description" />
  <div class="chart chart-vax-cases chart-block" bind:clientWidth={width}>
    <div class="tooltip">Tooltip</div>
    <div class="latest-data">
      <div class="latest-number">{formatThousands(latestVaccCount)}</div>
      <div class="latest-date">{formatDateLong(latestDate)}</div>
    </div>
    <svg {width} {height}>
      <!-- <defs>
        <filter id="filter1" x="0" y="0">
          <feOffset result="offOut" in="white" dx="0" dy="0" />

          <feGaussianBlur result="blurOut" in="offOut" stdDeviation="1" />
          <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
        </filter>
      </defs> -->
      <Grid
        type="y"
        ticks={{ x: xTicks, y: manualYTicks }}
        scale={{ x: xScale, y: yScale }}
        {height}
        {width}
      />
      <!-- <Axis
        type="y"
        {height}
        {width}
        scale={{ x: xScale, y: yScale }}
        ticks={{ x: xTicks, y: yTicks }}
      /> -->

      <AxisManual
        type="y"
        {height}
        {width}
        scale={{ x: xScale, y: yScale }}
        ticks={{ x: xTicks, y: yTicks }}
        {manualYTicks}
      />

      <AxisManual
        type="x"
        {height}
        {width}
        scale={{ x: xScale, y: yScale }}
        ticks={{ x: xTicks, y: yTicks }}
        {manualXTicks}
        xLabel=" days"
      />
      <!-- <Axis
        type="x"
        {height}
        {width}
        scale={{ x: xScale, y: yScale }}
        ticks={{ x: xTicks, y: yTicks }}
      /> -->

      <!-- Wave One -->
      <Line
        {height}
        {width}
        stroke={colors['cbaqua']}
        strokeWidth="2"
        scale={{ x: xScale, y: yScale }}
        data={waveOne}
        values={{ x: 'marker', y: 'casesSevenDays' }}
      />

      <!-- Wave Two -->
      <Line
        {height}
        {width}
        stroke={colors['cbblue']}
        strokeWidth="2"
        scale={{ x: xScale, y: yScale }}
        data={waveTwo}
        values={{ x: 'marker', y: 'casesSevenDays' }}
      />

      <!-- Wave THree -->
      <Line
        {height}
        {width}
        stroke={colors['ftgreen']}
        strokeWidth="2"
        scale={{ x: xScale, y: yScale }}
        data={waveThree}
        values={{ x: 'marker', y: 'casesSevenDays' }}
      />

      <!-- Wave THree -->
      <Line
        {height}
        {width}
        stroke={colors['cbred']}
        strokeWidth="3"
        scale={{ x: xScale, y: yScale }}
        data={waveFour}
        values={{ x: 'marker', y: 'casesSevenDays' }}
      />
      <!-- omicron wave -->
      <Annotation
        scale={{ x: xScale, y: yScale }}
        color={colors['cbred']}
        x={waveFour[waveFour.length - 1]}
        y={waveFour[waveFour.length - 1]}
        text="Omicron wave"
        anchor="middle"
        offsetY="-5"
      />
      <!-- first wave-->
      <Annotation
        scale={{ x: xScale, y: yScale }}
        color={colors['cbaqua']}
        x={waveOne[95]}
        y={waveOne[95]}
        text="First wave"
        anchor="end"
        offsetX="-10"
        offsetY="-5"
      />
      <!-- // second wave -->
      <Annotation
        scale={{ x: xScale, y: yScale }}
        color={colors['cbblue']}
        x={waveTwo[100]}
        y={waveTwo[100]}
        text="Beta wave"
        anchor="start"
        offsetX="-5"
        offsetY="-5"
      />

      <!-- // delta wave -->
      <Annotation
        scale={{ x: xScale, y: yScale }}
        color={colors['ftgreen']}
        x={waveThree[150]}
        y={waveThree[150]}
        text="Delta wave"
        anchor="middle"
        offsetX="0"
        offsetY="-25"
      />
    </svg>
  </div>
</div>
<p class="disclaimer">
  Note: This chart is indicative of the predominant variant for each of the
  waves. This is not an indication of the absolute number of variant cases.
</p>

<style>
  .chart {
    position: relative;
    font-family: 'Titillium Web', Arial, Helvetica, sans-serif;
    width: 100%;

    min-height: 250px;
    margin: 0 auto;
  }

  .latest-data {
    position: absolute;
    top: 20px;
    left: 20px;
    line-height: 100%;
    left: -10000px;
  }
  .latest-number {
    background: var(--darkgreen);
    color: #fff;
    padding: 4px 6px;
    font-size: 80%;
    border-radius: 5px;
  }
  .latest-date {
    font-size: 70%;
    margin-top: 2px;
    margin-bottom: 3px;
  }
  svg {
    margin-top: 18px;
  }
</style>
